import { BucketProvider } from "./CatalogBucketContext";
import { BucketPage } from "./CatalogBucketPage";

type Props = {};
const CatalogBuckets = (props: Props) => {
	return (
		<BucketProvider>
			<BucketPage />
		</BucketProvider>
	);
};
export default CatalogBuckets;
